// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* recentMediaUpload.css */

/* ── Container ───────────────────────────────────────────── */

.scl--cms-components-recentMediaUpload {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  max-width: 431px;
  height: 75px;
  background: #FFFFFF;
  border: 1px dashed #D0D5DD;
  border-radius: 10px;
  flex-shrink: 0;
  overflow: hidden;
}

/* ── Thumbnail ───────────────────────────────────────────── */

.scl--cms-components-recentMediaUpload-avatar {
  position: absolute;
  width: 40px;
  height: 40px;
  left: 16px;
  top: 17.5px;
  border-radius: 4px;
  overflow: hidden;
  background: #E1E5EC;
}

.scl--cms-components-recentMediaUpload-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.scl--cms-components-recentMediaUpload-avatarPlaceholder {
  width: 100%;
  height: 100%;
  background: #E1E5EC;
}

/* ── Content block ───────────────────────────────────────── */

.scl--cms-components-recentMediaUpload-content {
  position: absolute;
  left: 72px;
  top: 17px;
  width: 348px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  /* Promote to its own compositing layer so progress bar
     animation does not repaint siblings above it */
  isolation: isolate;
  will-change: contents;
}

/* ── File name ───────────────────────────────────────────── */

.scl--cms-components-recentMediaUpload-name {
  width: 348px;
  height: 16px;
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-style: normal;
  font-weight: 500;
  font-size: var(--font-size-14, 14px);
  line-height: var(--line-height-20, 20px);
  color: var(--typography-text-body-primary, #323539);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

/* ── Meta row ────────────────────────────────────────────── */
.scl--cms-components-recentMediaUpload-meta {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  height: 22px;
  position: relative;
  z-index: 2;

  /* Prevent any child width change from reflowing the row */
  width: 348px;
  flex-shrink: 0;
  overflow: hidden;
}

.scl--cms-components-recentMediaUpload-size {
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-weight: 400;
  font-size: 10px;
  line-height: 22px;
  color: var(--typography-text-body-secondary, #8A8B8F);
  white-space: nowrap;
  display: flex;
  align-items: center;

  /* Fixed width prevents reflow pushing siblings on every size update */
  width: 100px;
  flex-shrink: 0;
  overflow: hidden;
}

.scl--cms-components-recentMediaUpload-dot {
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-size: 10px;
  line-height: 22px;
  color: var(--typography-text-body-secondary, #8A8B8F);
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.scl--cms-components-recentMediaUpload-statusIcon {
  width: 9px;
  height: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Spinning animation for uploading state */
.scl--cms-components-recentMediaUpload-spinner {
  animation: scl--cms-components-recentMediaUpload-spin 0.75s linear infinite;
  transform-origin: center;
  display: block;
}

@keyframes scl--cms-components-recentMediaUpload-spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

.scl--cms-components-recentMediaUpload-statusLabel {
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-weight: 400;
  font-size: 10px;
  line-height: 22px;
  color: var(--typography-text-body-secondary, #8A8B8F);
  display: flex;
  align-items: flex-end;
  white-space: nowrap;

}

/* ── Action buttons ──────────────────────────────────────── */

.scl--cms-components-recentMediaUpload-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.scl--cms-components-recentMediaUpload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.15s ease;
}

.scl--cms-components-recentMediaUpload-btn:hover {
  opacity: 0.65;
}

.scl--cms-components-recentMediaUpload-btn--cancel {
  width: 9px;
  height: 9px;
}

.scl--cms-components-recentMediaUpload-btn--edit {
  width: 7px;
  height: 7px;
  background: #FFFFFF;
  border-radius: 1px;
}

.scl--cms-components-recentMediaUpload-btn--delete {
  width: 9px;
  height: 9px;
  background: #FFFFFF;
  border-radius: 1px;
}
.scl--cms-components-recentMediaUpload-btn--retry {
  width: 8px;
  height: 8px;
}

/* ── Progress track ──────────────────────────────────────── */

.scl--cms-components-recentMediaUpload-track {
  width: 348px;
  height: 4px;
  background: #DEE2E6;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;

  /* Contain the animated fill inside its own layer */
  isolation: isolate;
  position: relative;
  z-index: 0;
}

.scl--cms-components-recentMediaUpload-fill--uploading {
  height: 100%;
  border-radius: 6px;
  background: #2388FF;
  transition: width 0.15s linear;
}

/* ── Progress fill states ──────────────────────────────────── */

.scl--cms-components-recentMediaUpload-fill--complete,
.scl--cms-components-recentMediaUpload-fill--failed {
  height: 100%;
  width: 100% !important;
  border-radius: 6px;
  position: relative;
  isolation: isolate;
  overflow: hidden;
}

/* Solid base colors */
.scl--cms-components-recentMediaUpload-fill--complete {
  background: #84A578;
}

.scl--cms-components-recentMediaUpload-fill--failed {
  background: #FE566B;
}

/* Striped overlay — absolutely positioned on top of the solid fill */
.scl--cms-components-recentMediaUpload-fill--complete::after,
.scl--cms-components-recentMediaUpload-fill--failed::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;
  flex: none;
  order: 0;
  flex-grow: 0;
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent        25%,
    transparent        50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent        75%,
    transparent
  );
  background-size: 12px 12px;
  animation: scl--cms-components-recentMediaUpload-stripes 0.8s linear infinite;
}

.scl--cms-components-recentMediaUpload-fill--complete::before {
  content: attr(data-progress);
  position: relative;
  z-index: 1;
  flex: none;
  order: 1;
  flex-grow: 1;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #FFFFFF;

  width: 100%;
  height: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/dashboard-fs-cp/recent-activity-dsb-op/recent-upload-media/css/recentMediaUpload.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B,+DAA+D;;AAE/D;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,+DAA+D;;AAE/D;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+DAA+D;;AAE/D;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB;mDACiD;EACjD,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,+DAA+D;;AAE/D;EACE,YAAY;EACZ,YAAY;EACZ,0DAA0D;EAC1D,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,wCAAwC;EACxC,mDAAmD;EACnD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,UAAU;;EAEV,0DAA0D;EAC1D,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;;EAEnB,sEAAsE;EACtE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,eAAe;EACf,iBAAiB;EACjB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,2EAA2E;EAC3E,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,0DAA0D;EAC1D,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qDAAqD;EACrD,aAAa;EACb,qBAAqB;EACrB,mBAAmB;;AAErB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,+DAA+D;;AAE/D;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;;EAEd,mDAAmD;EACnD,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,iEAAiE;;AAEjE;;EAEE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,UAAU;EACV,QAAQ;EACR,YAAY;EACZ;;;;;;;;;GASC;EACD,0BAA0B;EAC1B,6EAA6E;AAC/E;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,YAAY;;EAEZ,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;;EAEd,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":["/* recentMediaUpload.css */\n\n/* ── Container ───────────────────────────────────────────── */\n\n.scl--cms-components-recentMediaUpload {\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  max-width: 431px;\n  height: 75px;\n  background: #FFFFFF;\n  border: 1px dashed #D0D5DD;\n  border-radius: 10px;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n/* ── Thumbnail ───────────────────────────────────────────── */\n\n.scl--cms-components-recentMediaUpload-avatar {\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  left: 16px;\n  top: 17.5px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: #E1E5EC;\n}\n\n.scl--cms-components-recentMediaUpload-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.scl--cms-components-recentMediaUpload-avatarPlaceholder {\n  width: 100%;\n  height: 100%;\n  background: #E1E5EC;\n}\n\n/* ── Content block ───────────────────────────────────────── */\n\n.scl--cms-components-recentMediaUpload-content {\n  position: absolute;\n  left: 72px;\n  top: 17px;\n  width: 348px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  /* Promote to its own compositing layer so progress bar\n     animation does not repaint siblings above it */\n  isolation: isolate;\n  will-change: contents;\n}\n\n/* ── File name ───────────────────────────────────────────── */\n\n.scl--cms-components-recentMediaUpload-name {\n  width: 348px;\n  height: 16px;\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-style: normal;\n  font-weight: 500;\n  font-size: var(--font-size-14, 14px);\n  line-height: var(--line-height-20, 20px);\n  color: var(--typography-text-body-primary, #323539);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n  align-items: center;\n}\n\n/* ── Meta row ────────────────────────────────────────────── */\n.scl--cms-components-recentMediaUpload-meta {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  height: 22px;\n  position: relative;\n  z-index: 2;\n\n  /* Prevent any child width change from reflowing the row */\n  width: 348px;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.scl--cms-components-recentMediaUpload-size {\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 22px;\n  color: var(--typography-text-body-secondary, #8A8B8F);\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n\n  /* Fixed width prevents reflow pushing siblings on every size update */\n  width: 100px;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.scl--cms-components-recentMediaUpload-dot {\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-size: 10px;\n  line-height: 22px;\n  color: var(--typography-text-body-secondary, #8A8B8F);\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.scl--cms-components-recentMediaUpload-statusIcon {\n  width: 9px;\n  height: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* Spinning animation for uploading state */\n.scl--cms-components-recentMediaUpload-spinner {\n  animation: scl--cms-components-recentMediaUpload-spin 0.75s linear infinite;\n  transform-origin: center;\n  display: block;\n}\n\n@keyframes scl--cms-components-recentMediaUpload-spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n.scl--cms-components-recentMediaUpload-statusLabel {\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 22px;\n  color: var(--typography-text-body-secondary, #8A8B8F);\n  display: flex;\n  align-items: flex-end;\n  white-space: nowrap;\n\n}\n\n/* ── Action buttons ──────────────────────────────────────── */\n\n.scl--cms-components-recentMediaUpload-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.scl--cms-components-recentMediaUpload-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: opacity 0.15s ease;\n}\n\n.scl--cms-components-recentMediaUpload-btn:hover {\n  opacity: 0.65;\n}\n\n.scl--cms-components-recentMediaUpload-btn--cancel {\n  width: 9px;\n  height: 9px;\n}\n\n.scl--cms-components-recentMediaUpload-btn--edit {\n  width: 7px;\n  height: 7px;\n  background: #FFFFFF;\n  border-radius: 1px;\n}\n\n.scl--cms-components-recentMediaUpload-btn--delete {\n  width: 9px;\n  height: 9px;\n  background: #FFFFFF;\n  border-radius: 1px;\n}\n.scl--cms-components-recentMediaUpload-btn--retry {\n  width: 8px;\n  height: 8px;\n}\n\n/* ── Progress track ──────────────────────────────────────── */\n\n.scl--cms-components-recentMediaUpload-track {\n  width: 348px;\n  height: 4px;\n  background: #DEE2E6;\n  border-radius: 6px;\n  overflow: hidden;\n  flex-shrink: 0;\n\n  /* Contain the animated fill inside its own layer */\n  isolation: isolate;\n  position: relative;\n  z-index: 0;\n}\n\n.scl--cms-components-recentMediaUpload-fill--uploading {\n  height: 100%;\n  border-radius: 6px;\n  background: #2388FF;\n  transition: width 0.15s linear;\n}\n\n/* ── Progress fill states ──────────────────────────────────── */\n\n.scl--cms-components-recentMediaUpload-fill--complete,\n.scl--cms-components-recentMediaUpload-fill--failed {\n  height: 100%;\n  width: 100% !important;\n  border-radius: 6px;\n  position: relative;\n  isolation: isolate;\n  overflow: hidden;\n}\n\n/* Solid base colors */\n.scl--cms-components-recentMediaUpload-fill--complete {\n  background: #84A578;\n}\n\n.scl--cms-components-recentMediaUpload-fill--failed {\n  background: #FE566B;\n}\n\n/* Striped overlay — absolutely positioned on top of the solid fill */\n.scl--cms-components-recentMediaUpload-fill--complete::after,\n.scl--cms-components-recentMediaUpload-fill--failed::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 0;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  background-image: linear-gradient(\n    45deg,\n    rgba(255, 255, 255, 0.15) 25%,\n    transparent        25%,\n    transparent        50%,\n    rgba(255, 255, 255, 0.15) 50%,\n    rgba(255, 255, 255, 0.15) 75%,\n    transparent        75%,\n    transparent\n  );\n  background-size: 12px 12px;\n  animation: scl--cms-components-recentMediaUpload-stripes 0.8s linear infinite;\n}\n\n.scl--cms-components-recentMediaUpload-fill--complete::before {\n  content: attr(data-progress);\n  position: relative;\n  z-index: 1;\n  flex: none;\n  order: 1;\n  flex-grow: 1;\n\n  font-family: 'Roboto', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  color: #FFFFFF;\n\n  width: 100%;\n  height: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
